import { Component, OnInit } from "@angular/core";
import * as registrationStrings from "../stringFiles/registration.json";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { State } from "country-state-city";
import { Router } from "@angular/router";
import { SchoolDetailsService } from "./school-details.service";
import { firstValueFrom } from "rxjs";
import * as loginStringsDetails from "../stringFiles/newLogin.json"
import { commonFunctionService } from "../utils/commonFunctions";
import { TranslateService } from "@ngx-translate/core";
import { BrandService } from "../brand/brand.service";

declare var $: any;
declare var customToastr: any;

@Component({
  selector: "app-school-details",
  templateUrl: "./school-details.component.html",
  styleUrl: "./school-details.component.css",
  providers: [SchoolDetailsService],
})
export class SchoolDetailsComponent implements OnInit {
  strings: any;
  otpPage: boolean;
  schoolDetails: boolean = false;
  classInstitutionError: any;
  yourNameError: boolean = false;
  localityError: boolean = false;
  addressError: boolean = false;
  pinCodeError: boolean = false;
  countryError: boolean = false;
  stateError: boolean = false;
  loader: boolean = false;
  projectDebounceTimer: any;
  yourNameLength: number = 0;
  localityLength: number = 0;
  addressLength: number = 0;
  pinCodeLength: number = 0
  formData = {
    countryName: "",
    stateName: "",
    yourName: "",
    locality: "",
    address: "",
    pinCode: "",
    instituteTypes: [],
  };
  countries: any[];
  states: any[];
  form: FormGroup;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  getAuthToken: any;
  loginStrings: any
  brand = this.brandService.brand;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private schoolDetailsService: SchoolDetailsService,
    private commonFunction: commonFunctionService,
    private translate: TranslateService,
    private brandService: BrandService
  ) {
    this.strings = registrationStrings;
    this.loginStrings = loginStringsDetails;
    this.states = [];
    this.schoolDetails = false;
    this.initScript();
  }

  ngOnInit() {
    this.form = this.fb.group({
      instituteType: [
        [],
        [Validators.required, this.customValidator.bind(this)],
      ],
    });
    this.checkSession()
    this.dropdownSettings = {
      singleSelection: false,
      idField: this.strings.pkInstituteTypeId,
      textField: this.strings.instituteTypeName,
      allowSearchFilter: false,
      enableCheckAll: false,
    };
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('usertoken='));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    this.getAuthToken = tokenValue;
    if (tokenValue) {
      this.getInstituteTypes();
    }
  }

  customValidator(control: AbstractControl) {
    const selectedItems = control.value;
    if (!selectedItems || selectedItems.length === 0) {
      return { required: true };
    }
    const instituteTypeIds = selectedItems.map(
      (data: any) => data.pkInstituteTypeId
    );
    this.formData.instituteTypes = instituteTypeIds;
    return null;
  }

  yourNameValidator(inputValue: string) {
    const name = inputValue.trim();
    this.formData.yourName = name;
    this.yourNameLength = name.length;
    if (this.yourNameLength < 2 && this.yourNameLength > 0) {
      this.yourNameError = true;
    } else {
      this.yourNameError = false;
    }
  }

  localityValidator(inputValue: string): void {
    const locality = inputValue.trim();
    this.formData.locality = locality;
    this.localityLength = locality.length;
    if (this.localityLength < 2 && this.localityLength > 0) {
      this.localityError = true;
    } else {
      this.localityError = false;
    }
  }

  addressValidator(inputValue: string): void {
    const address = inputValue.trim();
    this.formData.address = address;
    this.addressLength = address.length;
    if (this.addressLength < 4 && this.addressLength > 0) {
      this.addressError = true;
    } else {
      this.addressError = false;
    }
  }

  pinCodeValidator(inputValue: string): void {
    const regex = /^[0-9]{4,10}$/;
    this.pinCodeError = !regex.test(inputValue.trim());
    this.formData.pinCode = inputValue.trim();
    this.pinCodeLength = this.formData.pinCode.length
  }

  countryValidator(inputValue: string): void {
    this.countryError = !inputValue;
    this.formData.countryName = inputValue.trim();
  }

  stateValidator(inputValue: string, countryValue: string): void {
    this.stateError = !inputValue || !countryValue;
    this.formData.stateName = inputValue;
  }

  ngAfterViewInit(): void {
    if ($.fn.intlTelInput) {
      const selectCountryName = $("#country");
      selectCountryName.intlTelInput({
        initialCountry: this.brand.defaultCountryIso2Lower || "in",
        separateDialCode: false,
        utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.4/js/utils.js"
      });

      const getEnglishCountryName = (fullName: string): string => {
        return fullName.split(" (")[0];
      };

      // Ensure initial country logic is handled
      const initializeCountry = () => {
        const selectedCountryData = selectCountryName.intlTelInput("getSelectedCountryData");
        const englishCountryName = getEnglishCountryName(selectedCountryData.name);
        const countryIsoCode = selectedCountryData.iso2.toUpperCase();
        this.getStatesForCountry(countryIsoCode);
        this.formData.countryName = englishCountryName;
      };

      // Initialize the default country (India)
      initializeCountry();

      // Listen for country change event
      selectCountryName.on("countrychange", () => {
        initializeCountry();
      });
    } else {
      return;
    }
  }

  getStatesForCountry(countryIsoCode: string) {
    const states = State.getStatesOfCountry(countryIsoCode).map(
      (state) => state.name
    );
    this.states = states;
  }

  preventManualInput(event: KeyboardEvent) {
    event.preventDefault();
  }

  handleDebounceInstituteType(value): void {
    this.customValidator(value);
  }

  handleDebounceYourName(value: string): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.yourNameValidator(value);
    }, 800);
  }

  handleDebounceYourLocality(value: string): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.localityValidator(value);
    }, 800);
  }

  handleDebounceYourAddress(value: string): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.addressValidator(value);
    }, 800);
  }

  handleDebouncePinCode(value: string): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.pinCodeValidator(value);
    }, 800);
  }

  handleDebounceCountry(value: string): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.countryValidator(value);
    }, 800);
  }

  handleDebounceState(value: string, countryValue: string): void {
    clearTimeout(this.projectDebounceTimer);
    this.projectDebounceTimer = setTimeout(() => {
      this.stateValidator(value, countryValue);
    }, 800);
  }

  handleKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      "ArrowLeft",
      "ArrowRight",
      "Backspace",
      "Delete",
      "Home",
      "End",
    ];
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  onSubmit() {
    this.addInstituteInformationDetails();
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }

  async getInstituteTypes() {
    try {
      const response = await firstValueFrom(
        this.schoolDetailsService.getInstituteTypesApi(this.getAuthToken)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (
          responseDetails.body &&
          responseDetails.body.instituteTypes &&
          responseDetails.body.instituteTypes.length > 0
        ) {
          this.dropdownList = responseDetails.body.instituteTypes;
        }
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
    } catch (error) {
      
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
    }
  }

  async addInstituteInformationDetails() {
    try {
      this.loader = true;
      const body = {
        instituteTypes: this.formData.instituteTypes,
        registeredPersonName: this.formData.yourName,
        locality: this.formData.locality,
        address: this.formData.address,
        lang: "en",
        pinCode: this.formData.pinCode,
        state: this.formData.stateName,
        country: this.formData.countryName,
      };
      const response = await firstValueFrom(
        this.schoolDetailsService.addInstituteInformationDetailsApi(body, this.getAuthToken)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        customToastr(responseDetails.body.message, this.strings.successCode);
        this.formData.instituteTypes = [];
        this.formData.yourName = "";
        this.formData.locality = "";
        this.formData.address = "";
        this.formData.pinCode = "";
        this.formData.stateName = "";
        this.formData.countryName = "";
        this.yourNameLength = 0;
        this.localityLength = 0;
        this.addressLength = 0;
        this.schoolDetails = true;
        const hostName = window.location.hostname;
        const urlHost = hostName.split(".")[1];
        if (urlHost === this.loginStrings.localhost) {
          this.commonFunction.setCookieLocal(this.loginStrings.schoolAddress, responseDetails.body.loginInfo.step1Data.address, 7);
          this.commonFunction.setCookieLocal(this.loginStrings.phoneNumber, responseDetails.body.loginInfo.underVerificationData.phoneNumber, 7);
          this.commonFunction.setCookieLocal(this.loginStrings.schoolEmailId, responseDetails.body.loginInfo.underVerificationData.emailId, 7);
          this.commonFunction.setCookieLocal(this.loginStrings.schoolName, responseDetails.body.loginInfo.underVerificationData.schoolName, 7);
          this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
          this.commonFunction.setCookieLocal(this.loginStrings.countryCode, responseDetails.body.loginInfo.underVerificationData.countryCode, 7);
          this.commonFunction.setCookieLocal(this.loginStrings.schoolImage, responseDetails.body.loginInfo.underVerificationData.schoolImage, 7);
        } else {
          this.commonFunction.setCookie(this.loginStrings.schoolAddress, responseDetails.body.loginInfo.step1Data.address, 7);
          this.commonFunction.setCookie(this.loginStrings.phoneNumber, responseDetails.body.loginInfo.underVerificationData.phoneNumber, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolEmailId, responseDetails.body.loginInfo.underVerificationData.emailId, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolName, responseDetails.body.loginInfo.underVerificationData.schoolName, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
          this.commonFunction.setCookie(this.loginStrings.countryCode, responseDetails.body.loginInfo.underVerificationData.countryCode, 7);
          this.commonFunction.setCookie(this.loginStrings.schoolImage, responseDetails.body.loginInfo.underVerificationData.schoolImage, 7);
        }
        this.router.navigate(["/institute-under-verification"]);
      } else {
        customToastr(responseDetails.message, this.strings.errorCode);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.strings.errorCode
      );
      this.loader = false;
      return;
    }
  }

  checkSession() {
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    if (tokenValue) {
      const isFranchiseValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.isFranchise + this.loginStrings.equalTo));
      let isFranchise = isFranchiseValue ? isFranchiseValue.split('=')[1] : null;
      const schoolVerification = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolVerification + this.loginStrings.equalTo));
      let schoolVerificationValue = schoolVerification ? schoolVerification.split('=')[1] : null;
      if (schoolVerificationValue == this.loginStrings.step1) {
        this.router.navigate(["/institute-onboard/step/1"]);
      } else if (schoolVerificationValue === this.loginStrings.underVerification) {
        this.router.navigate(["/institute-under-verification"]);
      }
      else {
        if (isFranchise == "1") {
          this.router.navigate(["/franchise/dashboard"]);
        } else {
          this.router.navigate(["/dashboard"]);
        }
      }

    } else {
      this.router.navigate(["/login"]);
    }
  }
}
